import {Component, Input, OnInit} from '@angular/core';
import {interval, Subscription} from "rxjs";
import {Calibrationdataservice} from "../calibrationdataservice";
import {CalibrationData} from "../calibrationStatus";
import {HttpClient} from "@angular/common/http";
import {Scale} from "@progress/kendo-angular-gauges";
import {UrlBuilder} from "../../url-builder/url.builder";
import {environment} from "../../../environments/environment";


enum eCONVERSION
{
  conversionVolt = 1,
  conversionGrC  = 0
}

@Component({
  selector: 'app-calibration',
  templateUrl: './calibration.component.html',
  styleUrls: ['./calibration.component.css']
})
export class CalibrationComponent implements OnInit {
  @Input()
  public currentConversion: eCONVERSION = eCONVERSION.conversionGrC;
  public aChannel: boolean = false;
  public uiChannel: number = 1;
  public calibrationData: CalibrationData;
  private channelSubscription: Subscription | undefined;
  private urlBuilder:UrlBuilder;
  public loaderStatus: number = 0;




  constructor(private calibrationdataservice: Calibrationdataservice, private http: HttpClient) {
    this.calibrationData = new CalibrationData();
    this.urlBuilder = new UrlBuilder();
  }


  ngOnInit(): void {
    this.UpdateChannel();
  }

  ReSubscribeChannel(): void{
    this.channelSubscription = interval(750).subscribe(
      () => {
        this.UpdateChannel();
      });
  }

  UpdateChannel(): void {
    this.channelSubscription?.unsubscribe();
    this.loaderStatus = -1;
    let url: string = this.urlBuilder.GetAiCalibrationChannelUrl()+ "/" + this.GetFullChannelFromUI() + "/" + this.currentConversion;
    console.log("URL", url);
    this.http.get<any>(url).subscribe(data => {
      this.loaderStatus = 1;
      console.log("Received", data);
      this.calibrationData = data;
      this.ReSubscribeChannel();
    })
  }

  ngOnDestroy(): void {
    this.channelSubscription?.unsubscribe();
  }

  // Sercom has always use channel number with a side channel
  // So 1 - 1A - 2 - 2A
  // This is still used by service and others.
  // But it are just 0-1-2-3-4- channels. So the program uses this normal numbers (zerobased)
  // Here we convert user interface to internal full channel numbers
  GetFullChannelFromUI():number
  {
    let ch: number = ((this.uiChannel-1) * 2);
    ch += (this.aChannel) ? 1 : 0;
    return ch;
  }


  ToggleAChannel() : void
  {
    if (this.currentConversion == eCONVERSION.conversionVolt)
    {
        this.aChannel = (this.aChannel) ? false : true;
    }
  }

  ToggleConversion(): void {
    this.currentConversion = (this.currentConversion == eCONVERSION.conversionGrC) ? eCONVERSION.conversionVolt : eCONVERSION.conversionGrC;
  }

  GetUnit(): string {
    return (this.currentConversion == eCONVERSION.conversionVolt) ? "Volt" : "°C";
  }

  GetValue(): number {
    if (this.currentConversion == eCONVERSION.conversionVolt)
      return this.calibrationData.adc_value / 200.0;
    else
      return this.calibrationData.adc_value / 10.0
  }

  GetScale(): Scale {
    let scaleGrC: Scale = new class implements Scale {
      max = 60;   // The service calibrates at -20 and +50
      min = -40;
    };
    let scaleVolt: Scale = new class implements Scale {
      max = 5;
      min = 0;
    };
    return (this.currentConversion == 1) ? scaleVolt : scaleGrC;
  }

}
